// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".anim-pages-enter-active,.anim-pages-leave-active{-webkit-transition:opacity .2s ease;transition:opacity .2s ease}.anim-pages-enter,.anim-pages-leave-active{opacity:0}html{overflow-y:auto!important}::-webkit-scrollbar{width:5px}::-webkit-scrollbar-track{background:#ddd}::-webkit-scrollbar-thumb{background:#bdbdbd}*{scrollbar-width:thin}", ""]);
// Exports
module.exports = exports;
